import { useContext, useEffect, useState } from "react";
import {
  jobIcon,
  clientsIcon,
  devicesIcon,
  settingIcon,
  doubArrwRight,
  doubArrwLeft,
  darkModeIcon,
  lightModeIcon,
  logOutIcon,
  etalonIcon,
} from "../../assets/icons";
import { logo } from "../../assets/logo";
import { HoverButton } from "../buttons/HoverButton";
import "./sidebar.css";
import { NavLink } from "react-router-dom";
import { logOut, updateRecord } from "../../server/fetchFunctions";
import { UserContext } from "./Root";

export default function SideBar() {
  const { user, setUser } = useContext(UserContext);
  const [hidden, toggleHidden] = useState(false);
  const [theme, setTheme] = useState(document.documentElement.getAttribute("color-theme") || user.theme);
  const [active, setActive] = useState(window.location.pathname);

  useEffect(() => {
    setTheme(user.theme);
  }, [user.theme]);

  const navigations = [
    {
      title: "Munkák",
      path: "/jobs",
      icon: jobIcon,
    },
    {
      title: "Partnerek",
      path: "/clients",
      icon: clientsIcon,
    },
    {
      title: "Eszközök",
      path: "/devices",
      icon: devicesIcon,
    },
    {
      title: "Etalonok",
      path: "/etalons",
      icon: etalonIcon,
    },
    {
      title: "Beállítás",
      path: "/settings",
      icon: settingIcon,
    },
  ];

  const toggleSideBar = () => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar?.classList.contains("hide")) {
      sidebar.classList.remove("hide");
      toggleHidden(false);
    } else {
      sidebar?.classList.add("hide");
      toggleHidden(true);
    }
  };

  const toggleTheme = async () => {
    const t = theme === "light" ? "dark" : "light";
    document.documentElement.setAttribute("color-theme", t);

    setUser((prev: any) => ({ ...prev, theme: t }));
    await updateRecord("user", user.id, { theme: t });
  };

  const logout = async () => {
    await logOut();
    window.location.href = "/login";
  };

  //Auto hide sidebar if media is less then 1400px
  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (window.innerWidth < 1400) {
      sidebar?.classList.add("hide");
      toggleHidden(true);
    } else {
      sidebar?.classList.remove("hide");
      toggleHidden(false);
    }
  }, []);

  return (
    <aside id="sidebar" className="">
      <div className="sidebar-header">
        <NavLink to="/">
          <div className="logo">{logo}</div>
        </NavLink>
        <HoverButton onClick={toggleSideBar}>{hidden ? doubArrwRight : doubArrwLeft}</HoverButton>
      </div>
      <nav>
        <ul>
          {navigations.map((menu) => (
            <li key={menu.title} className={active === menu.path ? "active" : ""} title={hidden ? menu.title : ""}>
              <HoverButton>
                <NavLink to={menu.path} onClick={() => setActive(menu.path)}>
                  {menu.icon}
                  <span>{menu.title}</span>
                </NavLink>
              </HoverButton>
            </li>
          ))}
          <li></li>
          <li onClick={toggleTheme}>
            <HoverButton>
              <a href="#" title={hidden ? "Téma" : ""}>
                <span style={{ marginRight: "10px" }}>Téma:</span>
                {theme === "light" ? lightModeIcon : darkModeIcon}
              </a>
            </HoverButton>
          </li>
          <li onClick={logout} title={hidden ? "Kijelentkezés" : ""}>
            <HoverButton>
              {logOutIcon}
              <span>Kijelentkezés</span>
            </HoverButton>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
